import type { Filters } from '@/types/filters';
import type { ActiveFilterGroup } from '@/ui/components/ActiveFilters';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

const buildActiveFilterGroups = ({
  filters,
  formatValue = (value) => value,
  hiddenFilters = [],
  labels = {}
}: {
  filters: Partial<Filters>;
  formatValue?: (value: string, filterName: string) => string;
  hiddenFilters?: string[];
  labels?: Record<string, string>;
}): ActiveFilterGroup[] =>
  Object.entries(filters)
    .filter(([name]) => !hiddenFilters.includes(name))
    .map(([name, filterValue]) => ({
      label: labels[name] ?? snakeToTitleCase(name),
      name,
      values: (Array.isArray(filterValue) ? filterValue : [filterValue])
        .filter((value): value is string => !!value)
        .map((value) => ({ label: formatValue(value, name), value }))
    }));

export default buildActiveFilterGroups;
